import React from 'react';
import type { StatusTone } from '../types';
import './mobileAdminComponents.css';

const inferredTone = (status: string): StatusTone => {
    const value = status.toLowerCase();
    if (/failed|error|critical|compromised|disabled|revoked|expired/.test(value)) return 'danger';
    if (/warning|pending|partial|cancelling|locked/.test(value)) return 'warning';
    if (/complete|healthy|active|enabled|approved|resolved|ready/.test(value)) return 'success';
    if (/running|queued|syncing|open|acknowledged/.test(value)) return 'info';
    return 'neutral';
};

export function StatusBadge({ status, tone }: { status: string; tone?: StatusTone }) {
    const label = status.replace(/_/g, ' ');
    return <span className={`ma-badge ma-badge--${tone || inferredTone(status)}`}><span aria-hidden="true">●</span>{label}</span>;
}
